const Title = ({ title, onClick, icon = '‹', color = 'black' }) => {
  return (
    <div
      className='flex items-center gap-4 mb-4'
      style={{ color }}
    >
      <button
        className='text-2xl'
        onClick={onClick}
      >
        {icon}
      </button>
      <div className='text-xl font-bold'>{title}</div>
    </div>
  );
};

export default Title;
